import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {materialStore} from "@/store/materialStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';

export class MaterialService{
    private static instance: MaterialService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    materialStore = materialStore();
    globalStore = globalStore();

    public async index(data: any) {
        this.materialStore.loading = true;
        await http.get("getMateriales", {params: data}).subscribe({
            next: (response) => {
                this.materialStore.materialesListado = response.data.data;
                this.makePagination(response.data);
                this.materialStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.materialStore.loading = false;
            }
        })
    }

    public async getMateriales(txtSearch: string) {
        this.materialStore.loading = true;
        const data = {txtSearch: txtSearch}
        await http.get("materiales", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.materialStore.materiales = response.data
                    this.materialStore.loading = false;
                }
            },error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.materialStore.loading = false;
            }
        })
    }

    public async getUnidad() {
        await http.get("getUnidadMaterial").subscribe({
            next: (response:AxiosResponse) => {
                this.materialStore.unidad = response.data;
            },
        })
    }

    makePagination(page: any) {
        this.materialStore.pagination.per_page = page.per_page;
        this.materialStore.pagination.current_page = page.current_page;
        this.materialStore.pagination.last_page = page.last_page;
    }


    public async getGrupoMaterial() {
        await http.get("getGrupoMaterial").subscribe({
            next: (response:AxiosResponse) => {
                this.materialStore.grupoMaterial = response.data;
            },
        })
    }

    public async getPartidaGasto() {
        await http.get("getPartidaPresupuestaria").subscribe({
            next: (response:AxiosResponse) => {
                this.materialStore.partidaGasto = response.data;
            },
        })
    }

    public async saveMaterial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.materialStore.loading = true;
            http.post("addMaterial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.materialStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Material registrado correctamente");
                        this.materialStore.material = response.data.material
                        this.materialStore.newMaterial = response.data.material
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.materialStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async updateMaterial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.materialStore.loading = true;
            http.post("updateMaterial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.materialStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Material actualizado correctamente");
                        this.materialStore.material = response.data.material
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.materialStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async deleteMaterial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.materialStore.loading = true;
            http.post("deleteMaterial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.materialStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Material eliminado correctamente");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.materialStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async imprimirInventario(id:string) {
        await http.get(`imprimirInventario/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                window.open(
                    `${this.baseURL}imprimirInventario/${id}`, "_blank");
            },
        })
    }
    public async maximos(data: any) {
        await http.get(`maximos`, data).subscribe({
            next: (response:AxiosResponse) => {
                window.open(
                    `${this.baseURL}maximos`, "_blank");
            },
        })
    }


    public async adjuntarImagen(data:any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.materialStore.loading = true;
            http.post("adjuntarImagen", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.materialStore.loading = false;
                    if (response.data.success) {
                        this.materialStore.newMaterial = response.data.material
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.materialStore.loading = false;
                    reject(error);
                }
            })
        });
    }
}